export default {
  section_title: 'Gestione imposte',
  inherited_from_partner: 'Ereditato',
  inherited_from_region: 'Predefinito regionale',
  reset: 'Ripristina valore ereditato',
  form: {
    tax_name: {
      label: 'Nome imposta',
      tooltip: "Come viene chiamata l'imposta su scontrini e fatture, ad esempio IVA.",
    },
    tax_behaviour: {
      label: 'Gestione imposte',
      tooltip: 'Se i prezzi del menu includono già le imposte, o se le imposte vengono aggiunte al checkout.',
      options: {
        inclusive: 'Incluse nei prezzi del menu',
        exclusive: 'Aggiunte al checkout',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Aliquota imposta consegna',
      tooltip: "L'aliquota applicata al costo di consegna, che può differire da quella sul cibo.",
    },
  },
  impact: {
    title: 'Modificare la gestione imposte per i tuoi ristoranti?',
    affected_one: '{{count}} ristorante segue la tua impostazione predefinita e verrà modificato.',
    affected_other: '{{count}} ristoranti seguono la tua impostazione predefinita e verranno modificati.',
    overriding_one: "{{count}} ristorante ha un'impostazione personalizzata e la manterrà.",
    overriding_other: "{{count}} ristoranti hanno un'impostazione personalizzata e la manterranno.",
    confirm: 'Modificali',
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
  },
  toasts: {
    load_error: 'Impossibile caricare le impostazioni fiscali',
    impact_error: 'Impossibile verificare quali ristoranti sarebbero interessati',
    impact_changed_one: 'Il numero di ristoranti interessati è cambiato in {{count}}. Rivedi e salva di nuovo.',
    impact_changed_other: 'Il numero di ristoranti interessati è cambiato in {{count}}. Rivedi e salva di nuovo.',
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate',
  },
};
